// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM11.6259 14.4533L15.6911 18.5186L18.5195 15.6901L14.4543 11.6249C14.9811 10.0572 14.6208 8.25586 13.3709 7.006C12.0276 5.66262 10.0471 5.34686 8.40439 6.05579L8.03504 6.21519L8.19203 7.02435L10.2801 9.11241L9.11434 10.2782L7.02611 8.18992L6.21646 8.03361L6.05717 8.40249C5.34772 10.0454 5.66335 12.0263 7.00697 13.37C8.25684 14.6198 10.0582 14.9801 11.6259 14.4533Z"}}]};

const ToolsCircleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tools-circle-filled',
    ref,
    icon: element,
  },
));

ToolsCircleFilledIcon.displayName = 'ToolsCircleFilledIcon';

export default ToolsCircleFilledIcon;
